module.exports = __webpack_public_path__ + "static/media/kolhapur2.864f45ae.jpg";